import { render, staticRenderFns } from "./ymsOrderSyncRulesModal.vue?vue&type=template&id=25ba1a38&scoped=true"
import script from "./ymsOrderSyncRulesModal.vue?vue&type=script&lang=js"
export * from "./ymsOrderSyncRulesModal.vue?vue&type=script&lang=js"
import style0 from "./ymsOrderSyncRulesModal.vue?vue&type=style&index=0&id=25ba1a38&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ba1a38",
  null
  
)

export default component.exports